import { render } from "./products.vue?vue&type=template&id=0e1a7802&scoped=true"
import script from "./products.vue?vue&type=script&lang=js"
export * from "./products.vue?vue&type=script&lang=js"

import "./products.vue?vue&type=style&index=0&id=0e1a7802&scoped=true&lang=css"
import "./products.vue?vue&type=style&index=1&id=0e1a7802&lang=css"
script.render = render
script.__scopeId = "data-v-0e1a7802"

export default script